const UserTypes = [
  {
    name: "مدیر",
    type: 0,
    defaultPermission: 2147483647,
    chipColor: "error"
  },
  {
    name: "نماینده",
    type: 1,
    defaultPermission: 90,
    chipColor: "info"
  },
  {
    name: "کاربر",
    type: 2,
    defaultPermission: 16,
    chipColor: "warning"
  }
]
export default UserTypes;